import { colors } from 'ui/theme';

import { useRowIndex } from './Row';

export const useAlternatingRowBackgroundColor = () => {
  const rowNumber = useRowIndex();
  if (rowNumber !== undefined && rowNumber % 2 !== 0) {
    return `background-color: ${colors.grey1};`;
  }
};
